import { render, staticRenderFns } from "./CommercialBanner.vue?vue&type=template&id=5b184e0e&name=commercial-banner&"
import script from "./CommercialBanner.vue?vue&type=script&lang=js&"
export * from "./CommercialBanner.vue?vue&type=script&lang=js&"
import style0 from "./CommercialBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports